import * as React from "react"
import { Box, Button, Popover, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { tourShowLanguageSelector } from "../@signals"

export default function LanguageSelector({ anchorEl, onSelect }) {
    return (
        <Popover
            open={tourShowLanguageSelector.value}
            anchorEl={anchorEl}
            onClose={() => { tourShowLanguageSelector.value = false }}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            transformOrigin={{ vertical: "bottom", horizontal: "center" }}
            slotProps={{
                paper: {
                    sx: {
                        p: 2.5,
                        mb: 1,
                        borderRadius: "12px",
                        minWidth: 220,
                        boxShadow: "rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px",
                    }
                }
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, justifyContent: "center" }}>
                <Box
                    sx={{
                        backgroundColor: "primary.lighter",
                        borderRadius: "8px",
                        width: 28,
                        height: 28,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <IconSeeker icon="language" iconType="fontAwesome" sx={{ fontSize: 13, color: "primary.main" }} />
                </Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                    Select language
                </Typography>
            </Box>
            <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => onSelect("en")}
                    sx={{
                        textTransform: "none",
                        borderRadius: "8px",
                        borderColor: "divider",
                        color: "text.secondary",
                        fontWeight: 600,
                        flex: 1,
                        "&:hover": { borderColor: "primary.light", backgroundColor: "primary.lighter" },
                    }}
                >
                    English
                </Button>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => onSelect("es")}
                    sx={{
                        textTransform: "none",
                        borderRadius: "8px",
                        borderColor: "divider",
                        color: "text.secondary",
                        fontWeight: 600,
                        flex: 1,
                        "&:hover": { borderColor: "primary.light", backgroundColor: "primary.lighter" },
                    }}
                >
                    Español
                </Button>
            </Box>
        </Popover>
    )
}
